












import { Component, Vue, Prop } from 'vue-property-decorator';
import { v1 } from 'uuid'
import LivePlayer from './components/LivePlayer.vue'
import Notice from './components/NoticeSlider.vue'
import { liveRoomTypeenum } from '@/common/enums'
import { getUserInfo } from 'apiUtils/Login'
import { getTimeGap } from '../../utils/index'
// import getPrefix from '@/utils/constants'
@Component({
  components: {
    LivePlayer,
    Notice
  },
})
export default class ZnPlayer extends Vue {
  private sid!: string
  private roomId!: string
  private userId!: string
  private userName = ''
  private userImg!: string
  private nickName!: string
  private loading = false
  private needAuth = false
  private created () {
    getTimeGap()
    this.$store.dispatch('setMuted', true)
    this.getLoginInfo()
  }
  private mounted () {
     window.addEventListener('message', (event) => {
        if (window.parent !== event.source) {return}
        if (event.data.type === 'muted') {
          this.$store.dispatch('setMuted', event.data.value)
        }
    }, false);
  }
  private getLoginInfo () {
    const { sid, roomId, userId } = this.$route.query
    if (sid) {
      this.needAuth = true
      this.sid = this.$route.query.sid as string
      this.roomId = this.$route.query.roomId as string
      this.userId = this.$route.query.userId as string
      this.getUserInfo()
    } else {
      this.sid = `$ZNYOUKE@${v1().replace(/-/g, '').slice(0, 23).toUpperCase()}`
      this.userId = `$ZNYOUKE@${v1().replace(/-/g, '').slice(0, 20).toUpperCase()}uid`
      this.roomId = this.$route.query.roomId as string
      this.nickName = '游客'
      this.userImg = 'http://hrmsv3-mlearning-stg5.pingan.com.cn:20083/learn/app/default1'
    }
  }

  // private onClose () {
  //   window.parent.postMessage('onClose', 'http://127.0.0.1:8848')
  // }

  private async getUserInfo () {
    this.loading = true
    const resp = await getUserInfo({
      sid: this.sid,
      nonGzip: 1
    })
    this.loading = false
    if (+resp.code === 0) {
      const { userName,
              userImg = 'http://hrmsv3-mlearning-stg5.pingan.com.cn:20083/learn/app/default1',
              nickName
            } = resp.body;
      this.userName = userName
      this.userImg = userImg
      this.nickName = nickName
      return;
    }
  }

  private get isLiveStream () {
    return (this.$route.params.liveRoomType || '1') as string === liveRoomTypeenum.LIVEING
  }
  private get notInLivePatrol () {
    return !window.location.hash.includes('/livePatrol')
  }
  private get isMuted () {
    return this.$store.state.videoMuted
  }
}
